import { AUTH_URL } from "../../urls.api";

export const AUTO_LOGIN_URL = `${AUTH_URL}/auto-login`;
